<template>
	<section class="filters-by-time">
		<v-btn v-for="filter in filters" v-bind:key="filter.id" v-bind:class="{'active': filter.id === value}" v-on:click="applyFilter(filter)" v-bind:disabled="loading">
			{{filter.label}}
		</v-btn>
	</section>
</template>

<script>

function data() {
	return {
		filters: [
			{
				id: 1, value: 1, label: 'Día', days: 0,
			},
			{
				id: 2, value: 2, label: 'Semana', days: 7,
			},
			{
				id: 3, value: 3, label: 'Mes', days: 30,
			},
			{
				id: 4, value: 4, label: 'Año', days: 365,
			},
		],
	};
}

function applyFilter(filter) {
	this.$emit('apply-filter', filter);
}

export default {
	name: 'filters-by-time',
	data,
	props: {
		value: {
			type: Number,
			default: 1,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		applyFilter,
	},
};
</script>


<style lang="scss" scoped>
	.filters-by-time {
		color: map-get($colors, default-button-color);
		display: inline-flex;
		width: calc(102px * 4);

		button.btn {
			background-color: white !important;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
			color: map-get($colors, default-button-color);
			font-size: map-get($sizes, fourteen) !important;
			height: 40px;
			margin-left: 14px;
			max-width: 73px;

			&.active {
				background-color: map-get($colors, default-skyblue) !important;
				color: white;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// FiltersByTime.vue?06bc97c0